export const getFileType = (url: string): string => {
    const extMatch = url.match(/\.([a-zA-Z0-9]+)(?:\?|#|$)/);
    const ext = extMatch ? extMatch[1] : '';
    return ext || 'FILE';
};

const getFileNameFromUrl = (url: string): string => {
    const nameMatch = url.match(/\/([^/?#]+)(?:\?|#|$)/);
    return nameMatch ? decodeURIComponent(nameMatch[1]) : 'document';
};



export const handleDownloadFromUrl = async ({ url, fileName }: { url: string; fileName?: string }) => {
    if (!url) return;

    const formattedFileName = `${fileName || getFileNameFromUrl(url)}.${getFileType(url).toLowerCase()}`;
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Download failed');
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = window.document.createElement('a');
        link.href = objectUrl;
        link.download = formattedFileName;
        window.document.body.appendChild(link);
        link.click();
        window.document.body.removeChild(link);
        URL.revokeObjectURL(objectUrl);
    } catch (error) {
        console.error('Download error:', error);
        // Fallback: open in new tab if fetch/blob fails (e.g. CORS restriction)
        window.open(url, '_blank', 'noopener,noreferrer');
    } finally {
        // Any cleanup if necessary
    }
};

export default handleDownloadFromUrl;